<template>
    <el-container class="full" style="position: relative">
        <!-- 侧边 -->
        <el-aside width="200px">
            <div class="line"></div>
            <side-bar>
                <div slot="trademark" class="title-box">杰锐德管理后台</div>
                <div class="menu-wrapper" slot="router">
                    <component v-for="item in menuList" :key="item.name" :data="item" :is="item.children && item.children.length ? 'sub-menu' : 'menu-item'
                        " />
                </div>
            </side-bar>
        </el-aside>
        <el-container class="full-height bg-gray">
            <!-- 头部 -->
            <el-header class="no-padding index-header" style="height: 73px; z-index: 1999">
                <top-bar />
            </el-header>
            <!-- 主体 -->
            <div class="main">
                <router-view class="content" />
            </div>
        </el-container>
    </el-container>
</template>
<script>
/* eslint-disable space-infix-ops */

import TopBar from "../components/TopBar";
import SideBar from "../components/side-bar";
import MenuItem from "../components/side-bar/menu-item";
import SubMenu from "../components/side-bar/sub-menu";
import { mapState } from "vuex";

export default {
    name: "Index",
    data() {
        return {
            newOrders: [],
            dialogVisible: false,
            timer: null,
        };
    },
    components: {
        TopBar,
        SideBar,
        MenuItem,
        SubMenu,
    },
    computed: {
        ...mapState(["permissionList", "menuList"]),
    },
    watch: {},
};
</script>

<style lang="less">
.index-header {
    position: absolute;
    // background: rgba(7, 19, 62, 1);
    z-index: 2;
}

.el-header {
    padding-left: 0;
}
</style>
<style lang="less" scoped>
.menu-wrapper {
    height: calc(100vh - 73px);
    overflow: auto;
}

.line {
    width: 10px;
    height: 73px;
    background: #409eff;
    position: absolute;
    top: 0;
    left: 195px;
    z-index: 1;
}

.title-box {
    width: 201px;
    height: 73px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    background: #409eff;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
}

.full-height {
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
}

.main .content {
    padding: 20px;
    margin-top: 73px;
}

.news-item {
    display: flex;
    align-items: center;
    padding: 22px 30px;
    border-bottom: 1px solid #ccc;

    .icon {
        width: 52px;
        height: 52px;
    }

    .middle {
        text-align: left;
        width: 300px;
    }

    .sub-content {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }

    .btn {
        width: 88px;
        height: 40px;
        margin-left: auto;
        background: rgba(255, 192, 50, 1);
        border: none;
    }
}

:deep(.index-dialog) {
    :deep(.el-dialog__header) {
        padding: 0 !important;
    }

    :deep(.el-dialog__body) {
        padding-left: 0;
        padding-right: 0;
    }

    .dialog-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 98px;
        box-sizing: border-box;
        padding: 12px 30px;
        background: rgba(255, 192, 50, 1);

        .slogan {
            font-size: 22px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 30px;
        }

        .title {
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
        }

        .allBtn {
            background: rgba(255, 155, 13, 1);
            width: 120px;
            height: 40px;
            color: rgba(255, 255, 255, 1);
            border: none;
        }
    }
}
</style>
